import { selectorActiveNotifications } from "./selectorActiveNotifications";

import {
  NotificationHandleType,
  WSNotificationResponse
} from "../components/Notifications";
import { BackgroundCheckRequestContractorContext } from "../components/Notifications/templates/BackgroundCheckRequestContractor";

export const selectorBackgroundCheckRequestContractorNotifications = (
  responses: WSNotificationResponse[]
) => {
  return selectorActiveNotifications(responses).filter(response => {
    return (
      response.handle ===
      NotificationHandleType.BackgroundCheckRequestContractor
    );
  }) as Array<WSNotificationResponse<BackgroundCheckRequestContractorContext>>;
};
